import React from "react";

interface QuantityUpdateProps {
  value: number;
  onChange: (qty: number) => void;
  increment: () => void;
  decrement: () => void;
  deleteAction: () => void;
}
const QuantityUpdate = ({ value, decrement, increment, onChange, deleteAction }: QuantityUpdateProps) => {
  return (
    <div className="flex items-center space-x-2.5">
      {value < 2 ? (
        <button
          className="flex-shrink-0 ml-1 h-7.5 w-7.5 sm:h-8 sm:w-8 rounded-full text-accent-red-500 bg-white flex items-center justify-center border border-grey-border border-opacity-40"
          onClick={deleteAction}
        >
          {/* prettier-ignore */}
          <svg className="w-[50%]" viewBox="0 0 18 18" fill="none">
              <path d="M15.75 4.48499C13.2525 4.23749 10.74 4.10999 8.235 4.10999C6.75 4.10999 5.265 4.18499 3.78 4.33499L2.25 4.48499" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1.5"/>
              <path d="M6.375 3.7275L6.54 2.745C6.66 2.0325 6.75 1.5 8.0175 1.5H9.9825C11.25 1.5 11.3475 2.0625 11.46 2.7525L11.625 3.7275" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1.5"/>
              <path d="M14.1373 6.85498L13.6498 14.4075C13.5673 15.585 13.4998 16.5 11.4073 16.5H6.5923C4.4998 16.5 4.4323 15.585 4.3498 14.4075L3.8623 6.85498" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1.5"/>
              <path d="M7.74707 12.375H10.2446" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1.5"/>
              <path d="M7.125 9.375H10.875" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1.5"/>
            </svg>
        </button>
      ) : (
        <button
          className="flex-shrink-0 bg-white h-7 w-7 sm:h-8 sm:w-8 rounded-full border border-grey-border border-opacity-50 inline-flex items-center justify-center text-placeholder disabled:cursor-not-allowed"
          disabled={value < 2}
          onClick={decrement}
        >
          {/* prettier-ignore */}
          <svg className="w-[60%]" viewBox="0 0 18 18" fill="none">
          <path d="M4.5 9H13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </button>
      )}

      <div className="flex items-stretch">
        <input
          type="number"
          className=" w-8 block h-7.5 sm:w-8 sm:h-8 rounded-5 border-grey-divider focus:border-primary-500 border no-outline text-center  font-semibold text-xxxs sm:text-xs text-dark"
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          min={1}
          max={10}
        />
      </div>
      <button
        onClick={increment}
        className="flex-shrink-0 h-7 w-7 bg-white sm:h-8 sm:w-8 rounded-full border  border-grey-border border-opacity-50 inline-flex items-center justify-center text-placeholder"
      >
        {/* prettier-ignore */}
        <svg className="w-[60%]" viewBox="0 0 18 18" fill="none">
            <path d="M4.5 9H13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 13.5V4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
      </button>
    </div>
  );
};
export default QuantityUpdate;
